<template>
  <div
    ref="thisTab"
    class="rounded-md border-2 border-solid border-transparent transition duration-300"
    :class="{
      '!border-accent-1': active,
      '!border-gray-500': openDetail && !active,
    }"
    @click="
      active = true;
      acitvateBlock();
    "
  >
    <div
      class="box-border flex w-full items-start justify-between rounded-md bg-gray-600 p-2"
    >
      <div
        class="flex flex-1 items-start gap-2 font-inter text-[13px] font-medium leading-6 text-gray-100"
        :class="{
          '!text-gray-50': openDetail,
        }"
        :style="{ maxWidth: maxHeaderWidth }"
      >
        <div class="flex items-center gap-2">
          <div
            v-if="!noMove && !lock"
            class="drag-handle grid min-h-5 max-w-6 cursor-move items-center"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.8125 6.6875C8.52344 6.6875 9.125 6.11328 9.125 5.375C9.125 4.66406 8.52344 4.0625 7.8125 4.0625C7.07422 4.0625 6.5 4.66406 6.5 5.375C6.5 6.11328 7.07422 6.6875 7.8125 6.6875ZM7.8125 11.0625C8.52344 11.0625 9.125 10.4883 9.125 9.75C9.125 9.03906 8.52344 8.4375 7.8125 8.4375C7.07422 8.4375 6.5 9.03906 6.5 9.75C6.5 10.4883 7.07422 11.0625 7.8125 11.0625ZM9.125 14.125C9.125 13.4141 8.52344 12.8125 7.8125 12.8125C7.07422 12.8125 6.5 13.4141 6.5 14.125C6.5 14.8633 7.07422 15.4375 7.8125 15.4375C8.52344 15.4375 9.125 14.8633 9.125 14.125ZM12.1875 6.6875C12.8984 6.6875 13.5 6.11328 13.5 5.375C13.5 4.66406 12.8984 4.0625 12.1875 4.0625C11.4492 4.0625 10.875 4.66406 10.875 5.375C10.875 6.11328 11.4492 6.6875 12.1875 6.6875ZM13.5 9.75C13.5 9.03906 12.8984 8.4375 12.1875 8.4375C11.4492 8.4375 10.875 9.03906 10.875 9.75C10.875 10.4883 11.4492 11.0625 12.1875 11.0625C12.8984 11.0625 13.5 10.4883 13.5 9.75ZM12.1875 15.4375C12.8984 15.4375 13.5 14.8633 13.5 14.125C13.5 13.4141 12.8984 12.8125 12.1875 12.8125C11.4492 12.8125 10.875 13.4141 10.875 14.125C10.875 14.8633 11.4492 15.4375 12.1875 15.4375Z"
                fill="currentColor"
              />
            </svg>
          </div>
          <div
            v-if="lock"
            class="grid min-h-5 max-w-6 items-center"
            data-testid="t-tab-lock"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.8125 6.6875V8H12.1875V6.6875C12.1875 5.48438 11.2031 4.5 10 4.5C8.76953 4.5 7.8125 5.48438 7.8125 6.6875ZM6.0625 8V6.6875C6.0625 4.52734 7.8125 2.75 10 2.75C12.1602 2.75 13.9375 4.52734 13.9375 6.6875V8H14.375C15.332 8 16.125 8.79297 16.125 9.75V15C16.125 15.9844 15.332 16.75 14.375 16.75H5.625C4.64062 16.75 3.875 15.9844 3.875 15V9.75C3.875 8.79297 4.64062 8 5.625 8H6.0625Z"
                fill="currentColor"
              />
            </svg>
          </div>
          <div v-if="$slots.icon" class="grid min-h-5 max-w-6 items-center">
            <slot name="icon" />
          </div>
        </div>
        <div v-if="$slots.headerContent">
          <slot name="headerContent" />
        </div>
        <h2
          v-if="header !== '' && !$slots.headerContent"
          class="mr-2 flex flex-1 items-center cursor-pointer truncate font-inter text-[13px] font-medium leading-6 text-gray-100"
          :class="{
            '!text-gray-50': openDetail,
            'after:ml-1.5 after:inline-block after:h-[7px] after:w-[7px] after:rounded-full after:bg-accent-1':
              changed && !canBeReset,
          }"
          :title="header"
          @click="
            toggleOpen();
            active = openDetail;
            acitvateBlock();
          "
        >
          {{ header }}
          <span
            v-if="changed && canBeReset"
            class="ml-0.5 inline-flex items-center text-accent-1 cursor-pointer opacity-75 hover:opacity-100"
            tabindex="0"
            @click.stop="emits('reset')"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.5156 8.03906C13.8203 7.75781 13.8203 7.26562 13.5156 6.98438C13.2344 6.67969 12.7422 6.67969 12.4609 6.98438L10 9.44531L7.51562 6.98438C7.23438 6.67969 6.74219 6.67969 6.46094 6.98438C6.15625 7.26562 6.15625 7.75781 6.46094 8.03906L8.92188 10.5L6.46094 12.9844C6.15625 13.2656 6.15625 13.7578 6.46094 14.0391C6.74219 14.3438 7.23438 14.3438 7.51562 14.0391L10 11.5781L12.4609 14.0391C12.7422 14.3438 13.2344 14.3438 13.5156 14.0391C13.8203 13.7578 13.8203 13.2656 13.5156 12.9844L11.0547 10.5L13.5156 8.03906Z"
                fill="currentColor"
              />
            </svg>
          </span>
        </h2>
      </div>

      <div class="flex gap-2">
        <TButton
          v-if="toggleShow"
          :class="{
            '!outline !outline-2 !outline-accent-1': !show,
          }"
          :disabled="disabled"
          data-testid="t-tab-toggle-hide"
          @click="showHide"
        >
          <template #icon>
            <font-awesome-icon v-if="show" :icon="['fas', 'eye']" />
            <font-awesome-icon v-if="!show" :icon="['fas', 'eye-slash']" />
          </template>
        </TButton>

        <TButton
          v-if="showReplace"
          v-tooltip="replaceTooltip"
          data-testid="replace-block"
          :disabled="disabled"
          @click="$emit('replaceBlock')"
        >
          <template #icon>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.8125 6.25H11.7227V7.78125C11.7227 8.05469 11.8594 8.30078 12.1055 8.41016C12.3516 8.49219 12.6523 8.4375 12.8438 8.24609L15.0312 6.05859C15.2773 5.8125 15.2773 5.40234 15.0312 5.15625L12.8438 2.96875C12.6523 2.77734 12.3516 2.72266 12.1055 2.80469C11.8594 2.91406 11.7227 3.16016 11.7227 3.40625V4.9375H7.8125C5.13281 4.9375 3 7.09766 3 9.75C3 10.1328 3.27344 10.4062 3.65625 10.4062C4.01172 10.4062 4.3125 10.1328 4.3125 9.75C4.3125 7.83594 5.87109 6.25 7.8125 6.25ZM16.3438 9.09375C15.9609 9.09375 15.6875 9.39453 15.6875 9.75C15.6875 11.6914 14.1016 13.25 12.1875 13.25H8.25V11.7188C8.25 11.4727 8.08594 11.2266 7.83984 11.1172C7.59375 11.0352 7.29297 11.0898 7.12891 11.2539L4.91406 13.4414C4.66797 13.7148 4.66797 14.125 4.91406 14.3711L7.12891 16.5586C7.29297 16.75 7.59375 16.8047 7.83984 16.7227C8.08594 16.6133 8.25 16.3672 8.25 16.0938V14.5625H12.1875C14.8398 14.5625 17 12.4297 17 9.75C17 9.39453 16.6992 9.09375 16.3438 9.09375Z"
                fill="currentColor"
              />
            </svg>
          </template>
        </TButton>

        <TButton
          v-if="showRemove"
          v-tooltip="removeTooltip"
          :disabled="disabled || removeDisabled"
          data-testid="remove-block"
          @click="$emit('removeBlock')"
        >
          <template #icon>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.4688 4.9375C15.8242 4.9375 16.125 5.23828 16.125 5.59375C16.125 5.97656 15.8242 6.25 15.4688 6.25H15.1406L14.4844 15.1367C14.4023 16.0664 13.6641 16.75 12.7344 16.75H7.23828C6.30859 16.75 5.57031 16.0664 5.48828 15.1367L4.83203 6.25H4.53125C4.14844 6.25 3.875 5.97656 3.875 5.59375C3.875 5.23828 4.14844 4.9375 4.53125 4.9375H6.41797L7.42969 3.43359C7.70312 3.02344 8.19531 2.75 8.71484 2.75H11.2578C11.7773 2.75 12.2695 3.02344 12.543 3.43359L13.5547 4.9375H15.4688ZM8.71484 4.0625C8.63281 4.0625 8.55078 4.11719 8.52344 4.17188L8.00391 4.9375H11.9688L11.4492 4.17188C11.4219 4.11719 11.3398 4.0625 11.2578 4.0625H8.71484ZM13.8281 6.25H6.14453L6.80078 15.0547C6.82812 15.2734 7.01953 15.4375 7.23828 15.4375H12.7344C12.9531 15.4375 13.1445 15.2734 13.1719 15.0547L13.8281 6.25Z"
                fill="currentColor"
              />
            </svg>
          </template>
        </TButton>

        <TButton
          v-if="addIcon"
          data-testid="add-block"
          :disabled="disabled"
          @click="addBlock"
        >
          <template #icon>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.75 6.375V9.75H14.125C14.5234 9.75 14.875 10.1016 14.875 10.5C14.875 10.9219 14.5234 11.25 14.125 11.25H10.75V14.625C10.75 15.0469 10.3984 15.375 10 15.375C9.57812 15.375 9.25 15.0469 9.25 14.625V11.25H5.875C5.45312 11.25 5.125 10.9219 5.125 10.5C5.125 10.1016 5.45312 9.75 5.875 9.75H9.25V6.375C9.25 5.97656 9.57812 5.625 10 5.625C10.3984 5.625 10.75 5.97656 10.75 6.375Z"
                fill="currentColor"
              />
            </svg>
          </template>
        </TButton>

        <t-input-toggle
          v-if="!hideOpen"
          v-model="openDetail"
          data-testid="toggle-open"
          :disabled="disabled || disableClose"
          @update:model-value="
            active = openDetail;
            acitvateBlock();
          "
        />
      </div>
    </div>

    <transition name="slide-fade-dropdown">
      <div v-if="openDetail">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
import TInputToggle from "../TInputToggle/TInputToggle.vue";
import TButton from "../TButton/TButton.vue";
import { onClickOutside } from "@vueuse/core";
import { ref, onMounted, computed } from "vue";

const props = defineProps({
  header: {
    type: String,
    default: "",
  },
  defaultOpen: {
    type: Boolean,
    deafult: false,
  },
  disabled: {
    type: Boolean,
    deafult: false,
  },
  toggleShow: {
    type: Boolean,
    deafult: false,
  },
  showRemove: {
    type: Boolean,
    deafult: false,
  },
  defaultDisplayed: {
    type: Boolean,
    deafult: true,
  },
  noMove: {
    type: Boolean,
    deafult: false,
  },
  hideOpen: {
    type: Boolean,
    deafult: false,
  },
  addIcon: {
    type: Boolean,
    deafult: false,
  },
  disableClose: {
    type: Boolean,
    deafult: false,
  },
  changed: {
    type: Boolean,
    default: false,
  },
  lock: {
    type: Boolean,
    default: false,
  },
  showReplace: {
    type: Boolean,
    default: false,
  },
  canBeReset: {
    type: Boolean,
    default: false,
  },
  replaceTooltip: {
    type: String,
    default: "Replace",
  },
  removeTooltip: {
    type: String,
    default: "",
  },
  removeDisabled: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits([
  "showBlock",
  "hideBlock",
  "removeBlock",
  "replaceBlock",
  "acitvateBlock",
  "addBlock",
  "reset",
]);

const openDetail = ref(false);
const active = ref(false);
const show = ref(true);
const thisTab = ref();

const maxHeaderWidth = computed(() => {
  const sideButtons = [
    props.toggleShow,
    props.showReplace,
    props.showRemove,
    !props.hideOpen,
  ].filter(Boolean).length;
  let buttonsWidth = 0;
  if (sideButtons > 0) {
    buttonsWidth = sideButtons * 24 + (sideButtons - 1) * 8;
  }
  return `calc(100% - ${buttonsWidth}px)`;
});

function showHide() {
  show.value = !show.value;
  if (show.value) {
    emits("showBlock");
  } else {
    emits("hideBlock");
  }
}

function addBlock() {
  emits("addBlock");
  openDetail.value = true;
  active.value = true;
}

onClickOutside(thisTab, (event: any) => {
  if (!event.composedPath().includes(thisTab.value)) {
    active.value = false;
  }
});

function acitvateBlock() {
  if (active.value) {
    emits("acitvateBlock");
  }
}

function toggleOpen() {
  if (props.disableClose) {
    openDetail.value = true;
    return;
  }
  openDetail.value = !openDetail.value;
}

defineExpose({
  openDetail,
});

onMounted(() => {
  if (props.defaultOpen) {
    openDetail.value = true;
  }
  show.value = props.defaultDisplayed;
});
</script>
